export const ACTIVE = 'Active';
export const RETIRED = 'Retired';
